/**
 * Collection grid: Finish swatches → preview variant image + sync PDP links (?variant=) + variant price
 */
(() => {
  const initCard = (card) => {
    const img = card.querySelector('[data-ae-coll-main-img]');
    const imgLink = card.querySelector('[data-ae-coll-img-link]');
    const viewLink = card.querySelector('[data-ae-coll-view-link]');
    const priceEl = card.querySelector('[data-ae-coll-price]');
    const baseUrl = card.dataset.productUrl || '';
    const swatches = card.querySelectorAll('[data-ae-coll-swatch]');
    if (!baseUrl || swatches.length === 0) return;

    const defaultSrc = img ? img.dataset.defaultSrc || img.getAttribute('src') || '' : '';
    const defaultMoney =
      (priceEl && (priceEl.dataset.defaultMoney || priceEl.textContent.trim())) || '';

    const setActiveClass = (btn) => {
      swatches.forEach((b) => {
        b.classList.toggle('is-active', b === btn);
      });
    };

    const applyVariant = (btn) => {
      const vid = btn.dataset.variantId;
      const src = btn.dataset.imageSrc || '';
      const money = btn.dataset.variantMoney || '';
      if (!vid) return;

      if (img && src) img.src = src;
      const qs = `${baseUrl.split('?')[0]}?variant=${vid}`;
      if (imgLink) imgLink.setAttribute('href', qs);
      if (viewLink) viewLink.setAttribute('href', qs);
      if (priceEl && money) priceEl.textContent = money;
      setActiveClass(btn);
    };

    const reset = () => {
      if (img && defaultSrc) img.src = defaultSrc;
      if (imgLink) imgLink.setAttribute('href', baseUrl);
      if (viewLink) viewLink.setAttribute('href', baseUrl);
      if (priceEl && defaultMoney) priceEl.textContent = defaultMoney;
      swatches.forEach((b) => b.classList.remove('is-active'));
    };

    swatches.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        applyVariant(btn);
      });
      btn.addEventListener('mouseenter', () => applyVariant(btn));
      btn.addEventListener('focus', () => applyVariant(btn));
    });

    card.addEventListener('mouseleave', reset);

    card.addEventListener(
      'focusout',
      (e) => {
        if (!card.contains(e.relatedTarget)) reset();
      },
      true
    );
  };

  document.querySelectorAll('[data-ae-coll-card]').forEach(initCard);
})();
